<template lang="pug">
div.fil-box
	.modal-filbox.ss-filbox(dd='provider')
		.modal-filbox-content
			.tt-main.text-uppercase {{$t('ui.slot')}}
			.filter-close.ss-filbox-close
				img(src='assets/img/cancel-icon.png')
			.conbox
				.tt-item.text-capitalize {{$t('ui.provider')}}
				.filter-itembox.sgfilterbox
					span.sgfilter(:class="{'aaa' : providerSelected === 1 }" @click="changeProvider(1)")
						img(src='assets/img/provider/jili.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 8 }" @click="changeProvider(8)")
						img(src='assets/img/provider/epic.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 0 }" @click="changeProvider(0)")
						img(src='assets/img/provider/pgsoft.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 3 }" @click="changeProvider(3)")
						img(src='assets/img/provider/fc-gaming-w.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 16 }" @click="changeProvider(16)")
						img(src='assets/img/provider/Hacksaw.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 10 }" @click="changeProvider(10)")
						img(src='assets/img/provider/cq9.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 5 }" @click="changeProvider(5)")
						img(src='assets/img/provider/jdb.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 11 }" @click="changeProvider(11)")
						img(src='assets/img/provider/pragmatic.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 23 }" @click="changeProvider(23)")
						img(src='assets/img/provider/BNG.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 6 }" @click="changeProvider(6)")
						img(src='assets/img/provider/live22.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 22 }" @click="changeProvider(22)")
						img(src='assets/img/provider/NLC.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 27 }" @click="changeProvider(27)")
						img(src='assets/img/provider/ygr.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 4 }" @click="changeProvider(4)")
						img(src='assets/img/provider/yes-bingo.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 7 }" @click="changeProvider(7)")
						img(src='assets/img/provider/yl-gaming.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 14 }" @click="changeProvider(14)")
						img(src='assets/img/provider/SpadeGaming.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 12 }" @click="changeProvider(12)")
						img(src='assets/img/provider/Microgaming.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 13 }" @click="changeProvider(13)")
						img(src='assets/img/provider/Spinix.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 2 }" @click="changeProvider(2)")
						img(src='assets/img/provider/fastspin.png')
					//- span.sgfilter(:class="{'aaa' : providerSelected === 15 }" @click="changeProvider(15)")
						img(src='assets/img/provider/Bgaming.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 17 }" @click="changeProvider(17)")
						img(src='assets/img/provider/relaxgaming.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 18 }" @click="changeProvider(18)")
						img(src='assets/img/provider/evoplay.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 19 }" @click="changeProvider(19)")
						img(src='assets/img/provider/playngo.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 20 }" @click="changeProvider(20)")
						img(src='assets/img/provider/netent.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 21 }" @click="changeProvider(21)")
						img(src='assets/img/provider/redtiger.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 24 }" @click="changeProvider(24)")
						img(src='assets/img/provider/AdvantPlay.png')
					span.sgfilter(:class="{'aaa' : providerSelected === 25 }" @click="changeProvider(25)")
						img(src='assets/img/provider/Alize.png')
					//- span.sgfilter(:class="{'aaa' : providerSelected === 23 }" @click="changeProvider(26)")
						img(src='assets/img/provider/spb.png')
					
					//- span.sgfilter(:class="{'aaa' : providerSelected === 9 }" @click="changeProvider(9)")
						img(src='assets/img/provider/habanero.png')
					//- span.sgfilter(:class="{'aaa' : providerSelected === 26 }" @click="changeProvider(26)")
						img(src='assets/img/provider/wow.png')
			//- .confirmbox.ss-filbox-confirm Confirm
	template(v-if="!showMobile")
		topbar(v-if="currentPath !=='/livestream'")
		.conbox
			.hometabs
				tabList 			
	.tabbox
		.gbox-wrap.slot
			.gbox-menu-wrap
				.gbox-menu-wrap-add
					.gbox-menu-fav
						template(v-if="isLoggedIn")
							a.sgbtn.s-fav(href='javascript:void(0)' @click="toggleFav")
								img(v-if="!showFav" src='assets/img/fav-ss.png')
								img(v-else src='assets/img/fav-set.png')
						template(v-else)
							a.sgbtn.s-fav(href='javascript:void(0)' @click="openModal()")
								img(v-if="!showFav" src='assets/img/fav-ss.png')
					.gbox-menu-wrap
						.gbox-filbox.ss-filter(@click="showProvider")
							.nname {{getProvider}}
							.iicon
								img(src='assets/img/dropdown-icon.png')
						//- .gbox-filbox.ss-filter(dd='category')
							.nname Filter
							.iicon
								img(src='assets/img/filter-icon.png')
						.gbox-search.ss-search(@click="toggleSearch")
							.iicon
								img(src='assets/img/search-icon.png')
				.gbox-search-box.ss-search-box(:class="{'aaa': showSearch}")
					.search-games
						input.form-control(type='text' v-model="searchinput" placeholder='Search')
					span.search-cancel.ss-search-cancel(@click="cancelSearch")
						i.fa-regular.fa-circle-xmark
			//- .not-mobile.justify-content-end.mt-2
				.gbox-menu-fav
					template(v-if="isLoggedIn")
						a.sgbtn.s-fav(href='javascript:void(0)' @click="toggleFav")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
							img(v-else src='assets/img/fav-set.png')
					template(v-else)
						a.sgbtn.s-fav(href='javascript:void(0)' @click="openModal()")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
				.gbox-search-box.ss-search-box.aaa
					.search-games
						.iicon
							img(src='assets/img/search-icon.png')
						input.form-control(type='text' v-model="searchinput" placeholder='Search')
					//- span.search-cancel.ss-search-cancel.pointer(@click="cancelSearch") {{$t('ui.cancel')}}
			//- .gbox-menu-wrap-add
				.gbox-menu-fav.only-mobile
					template(v-if="isLoggedIn")
						a.sgbtn.s-fav(href='javascript:void(0)' @click="toggleFav")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
							img(v-else src='assets/img/fav-set.png')
					template(v-else)
						a.sgbtn.s-fav(href='javascript:void(0)' @click="openModal()")
							img(v-if="!showFav" src='assets/img/fav-ss.png')
				.gbox-search.ss-search.only-mobile(@click="toggleSearch")
					.iicon
						img(src='assets/img/search-icon.png')
				.gbox-menu-wrap
					.swiper.gbox-swiper
						.swiper-wrapper
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 8 }" @click="changeProvider(8)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 8 }")
									img.pro-img(src='assets/img/provider/epic.png')
								| EpicWin
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 1 }" @click="changeProvider(1)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 1 }")
									img.pro-img(src='assets/img/provider/jili.png')
								| Jili
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 3 }" @click="changeProvider(3)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 3 }")
									img.pro-img(src='assets/img/provider/fc-gaming-w.png')
								| FACHAI
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 0 }" @click="changeProvider(0)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 0 }")
									img.pro-img(src='assets/img/provider/pgsoft.png')
								| PG Soft
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 4 }" @click="changeProvider(4)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 4 }")
									img.pro-img(src='assets/img/provider/yes-bingo.png')
								| Yes Bingo
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 6 }" @click="changeProvider(6)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 6}")
									img.pro-img(src='assets/img/provider/live22.png')
								| Live22
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 2 }" @click="changeProvider(2)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 2 }")
									img.pro-img(src='assets/img/provider/fastspin.png')
								| Fastspin
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 5 }" @click="changeProvider(5)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 5 }")
									img.pro-img(src='assets/img/provider/jdb.png')
								| JDB
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 7 }" @click="changeProvider(7)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 7 }")
									img.pro-img(src='assets/img/provider/yl-gaming.png')
								| YL Gaming
							//.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 10 }" @click="changeProvider(10)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 10 }")
									img.pro-img(src='assets/img/provider/cq9.png')
								| CQ9
							//.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 9 }" @click="changeProvider(9)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 9}")
									img.pro-img(src='assets/img/provider/habanero.png')
								| Habanero
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 12}" @click="changeProvider(12)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 12}")
									img.pro-img(src='assets/img/provider/Microgaming.png')
								| MicroGaming
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 13}" @click="changeProvider(13)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 13}")
									img.pro-img(src='assets/img/provider/Spinix.png')
								| Spinix
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 14}" @click="changeProvider(14)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 14}")
									img.pro-img(src='assets/img/provider/spadegaming.png')
								| SpadeGaming
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 15}" @click="changeProvider(15)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 15}")
									img.pro-img(src='assets/img/provider/Bgaming.png')
								| BGaming
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 16}" @click="changeProvider(16)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 16}")
									img.pro-img(src='assets/img/provider/hacksaw.png')
								| Hacksaw
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 17}" @click="changeProvider(17)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 17}")
									img.pro-img(src='assets/img/provider/relaxgaming.png')
								| RelaxGaming
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 18}" @click="changeProvider(18)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 18}")
									img.pro-img(src='assets/img/provider/Evoplay.png')
								| Evoplay
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 19}" @click="changeProvider(19)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 19}")
									img.pro-img(src='assets/img/provider/playngo.png')
								| Play'n GO
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 20}" @click="changeProvider(20)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 20}")
									img.pro-img(src='assets/img/provider/netent.png')
								| NETENT
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 21}" @click="changeProvider(21)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 21}")
									img.pro-img(src='assets/img/provider/RT.png')
								| Red Tiger
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 22}" @click="changeProvider(22)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 22}")
									img.pro-img(src='assets/img/provider/NLC.png')
								| NLC
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 23}" @click="changeProvider(23)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 23}")
									img.pro-img(src='assets/img/provider/BNG.png')
								| BNG
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 24}" @click="changeProvider(24)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 24}")
									img.pro-img(src='assets/img/provider/AdvantPlay.png')
								| AdvantPlay
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 25}" @click="changeProvider(25)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 25}")
									img.pro-img(src='assets/img/provider/Alize.png')
								| Alize
							.swiper-slide.pointer(:class="{'active-slider' : providerSelected === 26}" @click="changeProvider(26)")
								a.sgbtn(href="javascript:void(0)" :class="{'aaa' : providerSelected === 26}")
									img.pro-img(src='assets/img/provider/spb.png')
								| SPRIBE
			//- .gbox-search-box.ss-search-box(:class="{'aaa': showSearch}")
				.search-games
					input.form-control(type='text' v-model="searchinput" placeholder='Search')
				span.search-cancel.ss-search-cancel.pointer(@click="cancelSearch") {{$t('ui.cancel')}}
			favList(v-if="showFav" :searchinput="searchinput")
			live22(v-if="providerSelected === 6 && !showFav" :searchinput="searchinput")
			pg(v-if="providerSelected === 0 && !showFav" :searchinput="searchinput")
			jili(v-if="providerSelected === 1 && !showFav" :searchinput="searchinput")
			fastspin(v-if="providerSelected === 2 && !showFav" :searchinput="searchinput")
			fc(v-if="providerSelected === 3 && !showFav" :searchinput="searchinput")
			yesbingo(v-if="providerSelected === 4 && !showFav" :searchinput="searchinput")
			jdb(v-if="providerSelected === 5 && !showFav" :searchinput="searchinput")
			yl(v-if="providerSelected === 7 && !showFav" :searchinput="searchinput")
			cq9(v-if="providerSelected === 10 && !showFav" :searchinput="searchinput")
			//- habanero(v-if="providerSelected === 9 && !showFav" :searchinput="searchinput")
			epic(v-if="providerSelected === 8 && !showFav" :searchinput="searchinput")
			pragmatic(v-if="providerSelected === 11 && !showFav" :searchinput="searchinput")
			microgaming(v-if="providerSelected === 12 && !showFav" :searchinput="searchinput")
			spinix(v-if="providerSelected === 13 && !showFav" :searchinput="searchinput")
			spadegaming(v-if="providerSelected === 14 && !showFav" :searchinput="searchinput")
			//- bgaming(v-if="providerSelected === 15 && !showFav" :searchinput="searchinput")
			hacksaw(v-if="providerSelected === 16 && !showFav" :searchinput="searchinput")
			relaxgaming(v-if="providerSelected === 17 && !showFav" :searchinput="searchinput")
			evoplay(v-if="providerSelected === 18 && !showFav" :searchinput="searchinput")
			playngo(v-if="providerSelected === 19 && !showFav" :searchinput="searchinput")
			netent(v-if="providerSelected === 20 && !showFav" :searchinput="searchinput")
			evort(v-if="providerSelected === 21 && !showFav" :searchinput="searchinput")
			nlc(v-if="providerSelected === 22 && !showFav" :searchinput="searchinput")
			bng(v-if="providerSelected === 23 && !showFav" :searchinput="searchinput")
			advantplay(v-if="providerSelected === 24 && !showFav" :searchinput="searchinput")
			alize(v-if="providerSelected === 25 && !showFav" :searchinput="searchinput")
			//- spb(v-if="providerSelected === 26 && !showFav" :searchinput="searchinput")
			ygr(v-if="providerSelected === 27 && !showFav" :searchinput="searchinput")
			//- wow(v-if="providerSelected === 26 && !showFav" :searchinput="searchinput")
	footerInfo
</template>
<script>
import config from "@/config";
import topbar from '@/views/default/_topBar.vue'
import tabList from '@/views/default/_tabs.vue'
import favList from '@/component/slot/_favList.vue'
import live22 from '@/component/slot/_live22.vue'
import pg from '@/component/slot/_pg.vue'
// import jili from '@/component/slot/launchopen/_jili.vue'
import jili from '@/component/slot/_jili.vue'
import fc from '@/component/slot/_fc.vue'
import fastspin from '@/component/slot/_fastSpin.vue'
import yesbingo from '@/component/slot/_yesBingo.vue'
import jdb from '@/component/slot/_jdb.vue'
import yl from '@/component/egame/_yl.vue'
import cq9 from '@/component/slot/_cq9.vue'
// import habanero from '@/component/slot/_habanero.vue'
import epic from '@/component/slot/_epicGame.vue'
import pragmatic from '@/component/slot/launchone/_pragmatic.vue'
// import pragmatic from '@/component/slot/_pragmatic.vue'
import microgaming from '@/component/slot/launchone/_microGaming.vue'
import spinix from '@/component/slot/launchone/_spinix.vue'
import spadegaming from '@/component/slot/launchone/_spadeGaming.vue'
// import bgaming from '@/component/slot/launchone/_bGaming.vue'
import hacksaw from '@/component/slot/launchone/_hacksaw.vue'
import relaxgaming from '@/component/slot/launchone/_relaxGaming.vue'
import evoplay from '@/component/slot/launchone/_evoplay.vue'
import playngo from '@/component/slot/launchone/_playngo.vue'
import netent from '@/component/slot/launchone/_netent.vue'
import evort from '@/component/slot/launchone/_rt.vue'
import nlc from '@/component/slot/launchone/_nlc.vue'
import bng from '@/component/slot/launchone/_bng.vue'
import advantplay from '@/component/slot/launchone/_advantPlay.vue'
import alize from '@/component/slot/launchone/_alize.vue'
import ygr from '@/component/slot/_ygr.vue'
// import wow from '@/component/slot/_wow.vue'
// import spb from '@/component/slot/launchone/_spb.vue'
import footerInfo from '@/views/default/_footer.vue'
export default {
	components:{
		topbar,
		tabList,
		favList,
		live22,
		pg,
		jili,
		fastspin,
		fc,
		yesbingo,
		jdb,
		yl,
		cq9,
		// habanero,
		epic,
		pragmatic,
		microgaming,
		spinix,
		spadegaming,
		// bgaming,
		hacksaw,
		relaxgaming,
		evoplay,
		playngo,
		netent,
		evort,
		nlc,
		bng,
		advantplay,
		alize,
		ygr,
		// wow,
		// spb,
		footerInfo
	},
	data(){
		return{
			feedback: {
				success: true,
				status: ""
			},
			loading:false,
			showMobile: false,
			providerSelected: 1,
			imgUrl: config.imageUrl,
			showSearch: false,
			providerList:[
				"PGSOFT",
				"JILI",
				"FASTSPIN",
				"FACHAI",
				"YESBINGO",
				"JDB",
				"LIVE22",
				"YLGAMING",
				"EpicWin",
				"HABANERO",
				"CQ9",
				"PRAGMATIC",
				"MICROGAMING",
				"SPINIX",
				"SPADEGAMING",
				"BGAMING",
				"HACKSAW",
				"RELAXGAMING",
				"EVOPLAY",
				"PLAY'NGO",
				"NETENT",
				"REDTIGER",
				"NLC",
				"BNG",
				"ADVANTPLAY",
				"ALIZE",
				"WOWGAMING",
				"YGR"
				// "SPRIBE",
			],
			searchinput:"",
			showFav: false,
      currentPath: ""
		}
	},
	computed: {
		isLoggedIn(){
			return this.$store.getters.isLoggedIn
		},
		accountID() {
			return this.$store.getters.accountID
		},
		sessionToken() {
			return this.$store.getters.sessionToken
		},
		getProvider(){
			return this.providerList[this.providerSelected]
		},
	},
	watch:{
    $route (to, from){
      this.currentPath = to.path
    }
	},	
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/slot`);
		this.getSeo("slot")
		this.checkSize()
		var vm = this
		$(window).resize(function () {
			vm.checkSize()
		});
	},
	// metaInfo(){
	// 	if(this.$store.state.user.seoInfo.meta_title && this.$store.state.user.seoInfo.meta_title === "slot"){
	// 		return{
	// 			title: this.$store.state.user.seoInfo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.seoInfo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.seoInfo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.seoInfo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.seoInfo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.seoInfo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.seoInfo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.seoInfo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.seoInfo.meta_image_url},
	// 			]
	// 		}
	// 	}else{
	// 		return{
	// 			title: this.$store.state.user.homeSeo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.homeSeo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.homeSeo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.homeSeo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.homeSeo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.homeSeo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.homeSeo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.homeSeo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.homeSeo.meta_image_url},
	// 			]
	// 		}
	// 	}


	// },
	mounted(){
		this.currentPath = this.$router.currentRoute.path
		// $(document).on('click', '.ss-filter', function () {
		//     var dd = $(this).attr('dd')
		//     $('.modal-filbox').removeClass('aaa')
		//     $('.modal-filbox[dd="' + dd + '"]').addClass('aaa')
		//     $('body').addClass('noscroll')
		//     return false;
		// })
		if(!_.isEmpty(this.$route.params)){
      if(this.$route.params.custom == true){
				this.providerSelected = 8
			}
			if(this.$route.params.target){
				this.providerSelected = Number(this.$route.params.target)
			}
    }

		$(document).on('click', '.ss-filbox-close', function () {
				$(this).closest('.modal-filbox').removeClass('aaa')
				$('body').removeClass('noscroll')
				return false;
		})
		if ($('.gbox-swiper').length) {
			const gboxSwiper = new Swiper('.gbox-swiper', {
				slidesPerView: 2.5,
				spaceBetween: 5,
				navigation: {
					nextEl: '.gbox-swiper-next',
					prevEl: '.gbox-swiper-prev'
				},
				breakpoints: {
					680: {
							slidesPerView: 5.5,
							spaceBetween: 20,
					},
					1280: {
							slidesPerView: 7.5,
							spaceBetween: 20,
					}
				}
			})

		}
	},
	methods:{
		openModal(){
			$("#logModal").modal('show')
		},
		toggleFav(){
			this.showFav = !this.showFav
		},
		toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},
		showProvider(){
			$('.modal-filbox').addClass('aaa')
			$('body').addClass('noscroll')
		},
		getSeo(page){
			let page_name = page
			this.$store
				.dispatch("user/getSeo", {page_name})
				.then(response => {
					this.loading = false;
					this.feedback.success = response.success
					if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
					} else {
						if((typeof response.status) != 'object'){
							this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
						}
					}
				})
				.catch(response => {
					this.loading = false;
					var vm = this;
					if((typeof response.status) != 'object'){
						this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
					}
				});
		},
		changeProvider(option){
			if(option !== this.providerSelected){
				this.providerSelected = option
			}
			$('.modal-filbox').removeClass('aaa')
			$('body').removeClass('noscroll')
			this.showFav = false
			// if(option === this.providerSelected){
			// 	return
			// }else{
			// 	this.providerSelected = option
			// }
		},
		checkSize(){
			if ($(window).width() < 681) {
				this.showMobile = true
			}else{
				this.showMobile = false
			}
		},
	}
}
</script>
<style lang="scss" scoped>
.iicon{
	@media(min-width: 681px) {
		position: inherit;
		max-width: 100% !important;
	}
	
}
.gbox-search .iicon{
	@media(min-width: 681px) {
		width: 30px;
		height: inherit;
	}
	
}
</style>
